import { css } from '@emotion/css'
import { theme } from '@dis/styles'

export const styles = {
  root: css`
    color: ${theme.palette.error.main};
  `,
}
